import { FormControl, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import LabelWithHR from "../../common/labels/labelWithHR";
import { cancellationReasonsDriveOff, cancellationReasonsParking } from "../../globals.js";

const font = { fontFamily: "Gilroy-Regular", fontSize: 16, color: "#444444" };

/** Cancellation reason dropdown; drive-off reasons for a gas station ticket, parking reasons otherwise. */
const CancellationReasonSelect = ({ ticket, value, onChange }) => {
  const { t } = useTranslation();
  const cancellationReasons = ticket?.gasStationZone
    ? cancellationReasonsDriveOff
    : cancellationReasonsParking;

  return (
    <div>
      <LabelWithHR label={t("ModalCancelTicket.CancellationReason")} />
      <FormControl fullWidth size="small">
        <Select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
          inputProps={{ "aria-label": t("ModalCancelTicket.CancellationReason") }}
          renderValue={(selected) =>
            selected ? t(`CancellationReasons.${selected}`) : t("ModalCancelTicket.Select")
          }
          sx={{ ...font, height: 40, backgroundColor: "white" }}
        >
          {cancellationReasons.map((reason) => (
            <MenuItem key={reason.value} value={reason.value} sx={font}>
              {t(`CancellationReasons.${reason.value}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default CancellationReasonSelect;
